// Textbausteine für die Beschreibung manuell erstellter Aufgaben (nach Kategorie)
export const textbausteine = {
  headerTextBeschreibungBeiGprOptionsfrist:
    'Bei dieser GRP ist die Optionsfrist erreicht. Entscheidung über Gruppe halten oder zurück geben.',
  grpOptionsfristTodos: `
    <div>Mögliche To Dos:</div>
    <div>
      <li>Namen melden</li>
      <li>Konti melden</li>
      <li>Reduzierung GRP-FS</li>
      <li>HiHi ggf. öffnen</li>
      <li>To Dos bei Gruppe zurückgeben</li>
      <li>3er GRP FS sperren</li>
      <li>PNR zurückgeben</li>
      <li>HiHi öffnen</li>
      <li>Status & Einkaufsart anpassen</li>
    </div>
  `,
  ZimmerkontingentErhoehen:
    'Bitte erhöhe das Zimmerkontingent wie in der zugehörigen Aufgabe “Zimmerkontingente prüfen” hinterlegt.',
  ZusatzterminePruefen:
    'Bitte prüft anhand der folgenden Informationen, ob ein Zusatztermin angefragt werden sollte:',
  HotelwechselPruefen: `
    <div>Bitte prüfe für den Termin folgende Hotelwechsel</div>
    <table>
      <tr>
        <td>Ort</td>
        <td>Altes Hotel</td>
        <td>Neues Hotel</td>
        <td>Hotel in Typo angelegt</td>
        <td>Weitere Infos</td>
        <td>Freigabe</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </table>

    <div>Grund für den Hotelwechsel (sollte von CM benannt werden):</div>
  `,
  ThVkReduktion:
    'Bitte TH/VK Reduktion wie folgt umsetzen. Bei Terminen mit Buchungen müssen nach Abschluss der Aufgabe das CSM durch taggen von Hannah Bast & Angela Weist informiert werden.',
  TerminAbsagen: 'Grund für die frühzeitige Absage:',
  PreiseUnterMtzAktualisieren:
    'Wir haben vom CM neue/aktualisierte Preise für die Durchführung unter MTZ erhalten. Bitte nutzt die entsprechende Kalk, um die Preise unter MTZ auch in Blank zu aktualisieren.',
  TicketingAnfrage:
    'Bei diesem VG müssen die Flugtickets ausgestellt werden. Daher bitten wir um Ticketing-Freigabe.',
  FlugplanaenderungAbsprache: `
    Bei diesem VG gibt es eine kritische FPÄ. Es gibt Alternativen innerhalb RES >50€. Bitte gemeinsam mit dem FOM eine Flugalternative abstimmen.
    <table>
      <tr>
        <td>Grund:</td>
        <td></td>
      </tr>
      <tr>
        <td>PNR Print:</td>
        <td></td>
      </tr>
      <tr>
        <td>Bereits gezahlter Aufpreis:</td>
        <td></td>
      </tr>
      <tr>
        <td>Sitzplatzreservierungen: Nein, Ja - ausgestellt ?</td>
        <td></td>
      </tr>
      <tr>
        <td>Kostenfreie Alternative:</td>
        <td></td>
      </tr>
      <tr>
        <td>Kostenpflichtige Alternative + EK Preis:</td>
        <td></td>
      </tr>
      <tr>
        <td>Zusätzlich geprüfte Alternativen:</td>
        <td></td>
      </tr>
      <tr>
        <td>Sonstiges:</td>
        <td></td>
      </tr>
    </table>
  `,
  InlandsflugAbsprache: `
    Bei diesem VG gibt es <b>keinen INFL mehr innerhalb der RES</b>. Es gibt nur noch Alternativen außerhalb der RES. Bitte gemeinsam mit dem FOM eine Flugalternative abstimmen.
    <table>
      <tr>
        <td>Betroffene Strecke:</td>
        <td></td>
      </tr>
      <tr>
        <td>Grund:</td>
        <td>
          FOM bitte auswählen:
          <br />
          <ol>
            <li>FPÄ<br />(INFL war mal innerhalb der RES, ist aufgrund einer FPÄ nun aber außerhalb der RES)</li>
            <li>Keine Verfügbarkeiten<br />(Alle möglichen INFL innerhalb der RES ausgebucht)</li>
            <li>Kein Angebot<br />(Es gibt grundsätzlich keine INFL innerhalb der RES für diesen Termin)</li>
        </ol></td>
      </tr>
      <tr>
        <td>Benötigte RES:</td>
        <td></td>
      </tr>
      <tr>
        <td>Alternative Flüge mit Flugnr/Flughäfen/Zeiten:</td>
        <td></td>
      </tr>
      <tr>
        <td>Flugaufpreis über TH:</td>
        <td></td>
      </tr>
      <tr>
        <td>Sonstige Infos:</td>
        <td></td>
      </tr>
    </table>
  `,
  VkReduktion:
    'Bitte VK Reduktion wie folgt umsetzen. Bei Terminen mit Buchungen müssen nach Abschluss der Aufgabe das CSM durch taggen von Hannah Bast & Angela Weist informiert werden.',
  Terminfreigabe: 'Bitte prüfe die vorgeschlagenen Termine und frage diese beim CM an.',
  Terminplanung: `
    @PM: Bitte folgende Infos befüllen:
    <br />
    <br />
    <b>Reisejahre - für welche Jahre sollen Termine geplant werden?</b>
    <br />
    <br />
    <br />
    <b>Anzahl Termine pro Monat – bitte gewünschte Terminanzahl pro Monat angeben + Terminanzahl gesamt</b>
    <br />
    <br />
    <br />
    <b>bei Neureisen: Grund für die neue Reise (z.B. Erweiterung Portfolio, Unterkunft Verfügbarkeit, Reiseleiterverfügbarkeit)</b>
    <br />
    <br />
    <br />
    <b>Sperrzeiten – konkrete Info wann kein H-Start möglich ist</b>
    <br />
    <br />
    <br />
    <b>Besonderheiten – auch für INFL</b>
    <br />
    <br />
    <br />
    <b>Preisdruck: ja/nein - relevant für TH Planung</b>
    <br />
    <br />
    <br />
    <b>Geplante Pax Anzahl (mit wie vielen Pax rechnen wir)</b>
    <br />
    <br />
  `,
  StornoStaffelEinkaufspreiseAnpassen: `
    Bitte den Staffelpreis auf X PAX anpassen.
    <table>
      <tr>
        <td>Betrag pro Person VORHER:</td>
        <td></td>
      </tr>
      <tr>
        <td>Betrag pro Person KORRIGIERT:</td>
        <td></td>
      </tr>
    </table>
  `,
  TransferkostenT4Pruefen:
    'Bitte überprüft die Anzahl und die Kosten der Transfers für diesen Termin in Blank, da die dort hinterlegten Transferkosten von den in Rechnung gestellten Kosten des Kreditors abweichen.',
  EinkaufspreiseDerVerlaengerungPruefen: `
    Bitte überprüft die VL-Buchung für diesen Vorgang. Die Preise weichen von der Kalk ab.
    <table>
      <tr>
        <td>Betrag pro Person VORHER:</td>
        <td></td>
      </tr>
      <tr>
        <td>Betrag pro Person KORRIGIERT:</td>
        <td></td>
      </tr>
    </table>
  `,
  TerminbezogeneAufpreisePruefen: `
    Bitte überprüft bzw. ergänzt den Aufpreis für den verlinkten Vorgang.
    <br />
    <br />
    <span style="text-decoration: underline">Hinweis:</span>
    <br />
    Aufgaben für das CSM → Team
    <br />
    Aufgaben für das DSM → Bearbeiter/in
  `,
  TvzBuchen: '[Zahllauf_Kreditor_Betrag_Währung] Bitte bucht die T-VZ für diesen Termin.',
  EinkaufspreisAbweichungKalkBlank: `
    Blank weicht zur Kalk ab, bitte verlinkte Leistung prüfen und korrigieren.
    <table>
      <tr>
        <td>Betrag pro Person VORHER:</td>
        <td></td>
      </tr>
      <tr>
        <td>Betrag pro Person KORRIGIERT:</td>
        <td></td>
      </tr>
    </table>
  `,
  KalkBlankRgAbweichung: `
    Der vom CM abgerechnete Betrag für die verlinkte Leistung stimmt weder mit der Kalk, noch mit Blank überein. Bitte korrekten Betrag ermitteln, in Kalk einpflegen und über Yield Fulfillment in Blank hinterlegen lassen.
    <table>
      <tr>
        <td>CM abgerechnete Leistung:</td>
        <td></td>
      </tr>
      <tr>
        <td>Kalk Betrag:</td>
        <td></td>
      </tr>
      <tr>
        <td>PAX-Staffelung:</td>
        <td></td>
      </tr>
      <tr>
        <td>Kommunikation zwischen CM und BUHA liegt vor (Ja/Nein):</td>
        <td></td>
      </tr>
      <tr>
        <td>Link zur Kalk:</td>
        <td></td>
      </tr>
    </table>
  `,
  KalkBlankAbweichungNachCmRueckmeldung: `
    Die in der Kalk/Blank hinterlegten Kosten für die verlinkte Leistung stimmen laut CM nicht. Bitte einmal prüfen und korrigieren und den korrekten Betrag ermitteln, in Kalk einpflegen und über Yield Fulfillment in Blank hinterlegen lassen.
    <table>
      <tr>
        <td>CM abgerechnete Leistung:</td>
        <td></td>
      </tr>
      <tr>
        <td>Kalk Betrag:</td>
        <td></td>
      </tr>
      <tr>
        <td>PAX-Staffelung:</td>
        <td></td>
      </tr>
      <tr>
        <td>Kommunikation zwischen CM und BUHA liegt vor (Ja/Nein):</td>
        <td></td>
      </tr>
      <tr>
        <td>Link zur Kalk:</td>
        <td></td>
      </tr>
    </table>
  `,
  PaxForecasting: `
    <table>
      <tr>
      <td><b>Reise:</b></td>
      <td>[Reise] → bitte Reise auch verlinken</td>
      </tr>
      <tr>
      <td><b>Betroffener Zeitraum: </b></td>
      <td>[Jahr + Monate]</td>
      </tr>
      <tr>
      <td><b>Grund der Anfrage: </b></td>
      <td>[Beschreibung durch CO, worauf soll der Fokus bei der Prüfung liegen? (z.B. Maßnahmen oder ZT Bedarf prüfen]</td>
      </tr>
      <tr>
      <td><b>Soll-Ist-Abweichung:</b></td>
      <td>
        <li>Aktueller Forecast: ___ PAX</li>
        <li>Aktueller SOLL-Stand: ___ PAX</li>
        <li>Aktueller Ist-Stand: ___ PAX</li>
        <li>Abweichung absolut: ___ PAX / Abweichung relativ: ___ %</li>
      </td>
      </tr>
    </table>
  `,
  ForecastAnpassungPruefen: `
    <span style="color: red;font-style: italic;">Bitte das Reisejahr und die zu prüfenden Monate im einheitlichen Format "Reisejahr / zu prüfende Monate" angeben
      <strong>(Bsp: 2026 / 08,10,12)</strong>
    </span>

    <table>
      <tr>
      <td><b>Reise:</b></td>
      <td>[Reise] → bitte Reise auch verlinken</td>
      </tr>
      <tr>
      <td><b>Betroffener Zeitraum:</b></td>
      <td>[Jahr]</td>
      </tr>
      <tr>
      <td><b>Grund der Anfrage: </b></td>
      <td>[Beschreibung durch PM, worauf soll der Fokus bei der Prüfung liegen? (z.B. Angabe, ob Terminrückgabe geprüft werden soll)]</td>
      </tr>
      <tr>
      <td><b>Zusätzliche Informationen / Erwartungen CM: </b></td>
      <td>[Input CM, sofern vorhanden]</td>
      </tr>
    </table>
  `,
  UnverbindlichesFlugangebot: `
    Für diesen VG benötigen wir ein Flugangebot.
    <table>
      <tr>
        <td><span style="color: #357DE8;">VG-Nr. (falls noch nicht im Manager)</span></td>
        <td><span style="color: #357DE8;">(bitte angeben, falls noch keine Verlinkung möglich ist)</span></td>
      </tr>
      <tr>
        <td>Routing/Flugnr wenn vorhanden:</td>
        <td></td>
      </tr>
      <tr>
        <td>Individualisierung:</td>
        <td>JA/NEIN (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Art der Individualisierung:</td>
        <td>Verlängerung/Upgrade/Stopover/Feeder (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Infos zur Individualisierung:</td>
        <td>Beschreibe: Welches Upgrade, Routing VL/Stopover, Restriktionen/Transferslots, Zwischenflüge, Fährzeiten, ...</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>
  `,
  VerbindlicheGruppenIndividualisierung: `
    Für diesen VG benötigen wir Feeder über die GRP:
    <table>
      <tr>
        <td><b>Feeder:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Ab/bis:</td>
        <td>3LC (bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>

    Für diesen VG benötigen wir eine RFVL über die GRP:
    <table>
      <tr>
        <td><b>Rückflugverlegung:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Datum des neuen Rückflugs:</td>
        <td>DD.MM.YYYY (bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>

    Für diesen VG benötigen wir ein UPGR über die GRP:
    <table>
      <tr>
        <td><b>Upgrades:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Beförderungsklasse:</td>
        <td>Prem Eco/Busi (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>

    Für diesen VG benötigen wir einen Stopover über die GRP:
    <table>
      <tr>
        <td><b>Stopover:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Wann:</td>
        <td>Hinflug/Rückflug (bitte angeben)</td>
      </tr>
      <tr>
        <td>Dauer:</td>
        <td>X Tage (bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>
  `,
  FlugSonderservices: `
    Bitte meldet folgende(s) Special Meal(s) an:
    <table>
      <tr>
        <td><b>Special Meals</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Art des Meals:</td>
        <td>(bitte auswählen)<br>
          VGML – vegan<br>
          VLML - vegetarisch<br>
          GFML – glutenfrei<br>
        NLML - laktosefrei</td>
      </tr>
      <tr>
        <td>Welcher Pax:</td>
        <td>Pax Name (bitte angeben)</td>
      </tr>
    </table>

    Bitte meldet den Rollstuhlservice an:
    <table>
      <tr>
        <td><b>Rollstuhlservice</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Welcher Pax:</td>
        <td>Pax Name (bitte angeben)</td>
      </tr>
      <tr>
        <td>Welcher Service:</td>
        <td>WCHR/WCHS (bitte auswählen)<br>
          WCHR: Kd kann Treppen selbst steigen<br>
          WCHS: Kd benötigt einen Lift für Treppen<br>
        </tr>
        <tr>
          <td>Besonderheiten:</td>
          <td></td>
        </tr>
      </table>

      Bitte hinterlegt die Vielfliegernummer(n):
      <table>
        <tr>
          <td><b>Vielfliegernummer</b></td>
          <td>Ja/Nein (bitte auswählen)</td>
        </tr>
        <tr>
          <td>Welcher Pax:</td>
          <td>Pax Name (bitte angeben)</td>
        </tr>
        <tr>
          <td>Airline & Nummer:</td>
          <td>Airline & Vielfliegernummer (bitte angeben)</td>
        </tr>
        <tr>
          <td>Besonderheiten:</td>
          <td></td>
        </tr>
      </table>
  `,
  FlugKontaktdaten: `
    Bitte hinterlegt die Kontaktdaten der KD im PNR:
    <table>
      <tr>
        <td><b>Email:</b></td>
        <td>E-Mail-Adresse (bitte angeben</td>
      </tr>
      <tr>
        <td><b>Mobil:</b></td>
        <td>Mobilnummer (bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>
  `,
  FlugSeats: `
    Bitte stellt die reservierten Sitzplätze aus:
    <table>
      <tr>
        <td><b>Seats Ausstellung:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>

    Bitte ändert die SPR wie folgt:
    <table>
      <tr>
        <td><b>Seats Änderung:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Änderungswunsch:</td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>

    Bitte prüft folgende SPR über die GRP:
    <table>
      <tr>
        <td><b>GRP Seats Anfrage:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Sitzplatzwunsch:</td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>
  `,
  UnverbindlicheAnfrageFlugumbuchung: `
    Bitte prüft folgende Umbuchung:
    <table>
      <tr>
        <td><b>Umbuchungswunsch:</b></td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Welcher Pax:</td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>
  `,
  VerbindlicheFlugstornosUmbuchung: `
    Bitte bucht wie folgt um:
    <table>
      <tr>
        <td><b>Verbindlicher Umbuchungsauftrag:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Welcher Pax:</td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Änderung:</td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </tr>
    </table>

    Bitte storniert wie folgt:
    <table>
      <tr>
        <td><b>Verbindlicher Stornoauftrag:</b></td>
        <td>Ja/Nein (bitte auswählen)</td>
      </tr>
      <tr>
        <td>Welcher Pax:</td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten:</td>
        <td></td>
      </table>
  `,
  KritischerNameChange: `
    Bitte nur nutzen, wenn Fehler lt. Sales Wiki „NICHT OK“!:
    <table>
      <tr>
        <td>Änderung Timeline:</td>
        <td>Änderung < 24 Std. oder Änderung > 24 Std. (bitte auswählen)</td>
        </tr>
        <tr>
          <td>Verursacher:</td>
          <td>SKR-Fehler oder KD-Fehler (bitte auswählen)</td>
        </tr>
        <tr>
          <td>Änderung für welchen Pax:</td>
          <td>(bitte angeben)</td>
        </tr>
        <tr>
          <td>Besonderheiten</td>
          <td></td>
        </tr>
      </table>
  `,
  UnkritischerNameChange: `
    Bitte nur nutzen, wenn Fehler lt. Sales Wiki „OK“!
    <table>
      <tr>
        <td>Änderung für welchen Pax:</td>
        <td>(bitte angeben)</td>
      </tr>
      <tr>
        <td>Besonderheiten</td>
        <td></td>
      </tr>
    </table>
  `,
  ThPlanung: `
    Reise: bitte verlinken<br>
    Reisejahr:<br>
    Peisdruck: ja/nein<br>
    Langstrecke oder INFL<br>
    Bleiben aktuelle RES bestehen oder gibt es Änderungen?<br>
    Gibt es eine Veränderung der bestehenden VTs?
  `,
  Flugverfuegbarkeit: `
  <table>
    <tr>
    <td><b>Reise</b></td>
    <td>bitte verlinken</td>
    </tr>
    <tr>
    <td><b>Reisejahr</b></td>
    <td></td>
    </tr>
    <tr>
    <td><b>relevante Monate</b></td>
    <td></td>
    </tr>
    <tr>
    <td><b>Anliegen/Grund für Prüfung</b></td>
    <td></td>
    </tr>
  </table>
  `,
  KundenschreibenVersenden: `
    Bitte versendet die Vorlagen an folgende Vorgänge

    <li>VG XXXXXXX - Vorlage XXXXXXX</li>
  `,
  KlaerungVonLeistungen: `
    <li>Problem:</li>
    <li>betroffene Leistung:</li>
    <li>Kreditor:</li>
    <li>Lösungsvorschlag (vom CM):</li>
    <li>sonstige Infos / zusätzlich geprüft:</li>
  `,
  GruppeTicketing: `
    In 7 Tagen ist die TKT Frist der GRP. Bitte prüfen & ausstellen.
  `,
  DurchfuehrungUnterMtz: `
    Liebes COM, wir können den folgenden Termin unter MTZ ohne Aufpreis für die Kunden durchführen. <br><br>

    Bitte geht auf die Kunden zu und besprecht mit ihnen, ob sie eine Umbuchung wünschen oder die Durchführung unter MTZ bevorzugen. Wir bitten euch, uns die Aufgabe mit der Info zur Entscheidung der Kunden im Kommentarfeld innerhalb von einer Woche zurückzusenden. <br><br>

    Sollten sich die Kunden weder für eine Umbuchung, noch für die Durchführung unter MTZ entscheiden und von der Reise zurücktreten wollen, würden wir euch bitten, den kostenfreien Storno umzusetzen. Bitte beachtet, dass wir auch in diesem Fall eine Rückmeldung benötigen!
  `,
  InlandsflugUeberTh: `
  Bei diesem Termin muss der INFL TH geprüft und ggf. angehoben werden.

  <table>
    <tr>
    <td><b>TH Langstrecke</b></td>
    <td><b>+ INFL</b></td>
    <td><b>= Gesamt</b></td>
    </tr>
    <tr>
    <td>X €</td>
    <td>Y €</td>
    <td>Z €</td>
    </tr>
    <tr>
    <td><b>EK Langstrecke</b></td>
    <td><b>+ INFL</b></td>
    <td><b>= Gesamt</b></td>
    </tr>
    <tr>
    <td>X €</td>
    <td>Y €</td>
    <td>Z €</td>
    </tr>
 </table>
  `,
};
